// extracted by mini-css-extract-plugin
export default {"content":"YgOUKblN","actions":"K0BJ6t8C","title":"x77DCyjq","email":"MrFbDCEX"};